import { useTranslation } from 'react-i18next';
import { MultiSelect } from '../selects';
import { FranchiseType } from '../../types';

type Props = {
  fullWidth?: boolean;
  value: FranchiseType[];
  onChange: (value: FranchiseType[]) => void;
  disabled?: boolean;
};

const FranchiseTypeFilter = ({ fullWidth, value, onChange, disabled }: Props) => {
  const { t } = useTranslation();
  const options = Object.values(FranchiseType) as FranchiseType[];

  return (
    <MultiSelect<FranchiseType>
      fullWidth={fullWidth}
      options={options}
      disabled={disabled}
      value={value}
      translationKey="operativeStructure.franchiseType"
      label={t('operativeStructure.franchiseType.label')}
      onChange={onChange}
      selectAll
    />
  );
};

export default FranchiseTypeFilter;
